const isFunction = (functionToCheck) => !!(typeof functionToCheck === 'function'
    && !!functionToCheck.constructor
    && !!functionToCheck.call
    && !!functionToCheck.apply);

export { isFunction as default };
//# sourceMappingURL=isFunction.js.map
